import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/fly': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M197.8 427.8c12.9 11.7 33.7 33.3 33.2 50.7 0 0.8-0.1 1.6-0.1 2.5-1.8 19.8-18.8 31.1-39.1 31-25-0.1-39.9-16.8-38.7-35.8 1-16.2 20.5-36.7 32.4-47.6 2.3-2.1 2.7-2.7 5.6-3.6 3.4 0 3.9 0.3 6.7 2.8zM331.9 67.3c23.9 40 27.8 73.3 20.8 112.5-15.2 69.9-103.6 166.5-155.9 215.7-1.7 1.6-1.4 1.4-3.5 2.1l-3.3-0.1c-1.7-0.6-4.5-3.5-6.2-5.1-58.8-57.8-148.7-151.6-155.8-233.8-1.5-71.4 29.3-113.4 82.9-141.3 9.9-4.1 37-17.3 81.1-17.3 22-0.2 51.1 4.5 76.6 15.2 24.7 11.5 47 26.4 63.3 52.1zM186.8 351.9v-325.7c-57.9 5.5-72.7 89.2-69.3 136.7 4.1 58.3 41.3 137.9 69.3 189zM328.7 180c15.8-54.9-10.9-134.7-99.7-153 38.2 25.6 49.6 85.5 48 131.4-2 58.6-39.4 140-67.2 191.9 41.6-42.3 102.5-113.5 118.9-170.3z'
      }
    ]
  }
})
